import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import removeEmpty from '../../../utils/removeEmptyValuesFromObject';

const fetchFixedBudgetVesselAccCodeQuery = (data) => {
  const cleanedData = removeEmpty(data);
  return axios.post(apiurl?.getFixedBudgetVesselAccCodeList, cleanedData);
};

const fetchFixedBudgetVesselAccCodes = (data) => {
  return useQuery(
    ['getFixedBudgetVesselAccCodeList', data],
    () => fetchFixedBudgetVesselAccCodeQuery(data),
    { refetchOnWindowFocus: false }
  );
};

export default fetchFixedBudgetVesselAccCodes;
